import { CanvasDataChange } from "../types/canvasTypes";
import { ViewportShape } from "../types/objectTypes";
import { z } from "zod";
import { t } from "i18next";
import { parseViewportSize } from "../utils/viewportUtils";

export const getDefaultViewportObject = (width: number, height: number): ViewportShape => {
  // We don't need to add all the properties here, this directly goes to API
  // @ts-ignore
  const viewport: ViewportShape = {
    top: 0,
    fill: "#ffffff",
    left: 0,
    type: "rect",
    angle: 0,
    flipX: false,
    flipY: false,
    skewX: 0,
    skewY: 0,
    width,
    height,
    scaleX: 1,
    scaleY: 1,
    evented: false,
    meaning: "viewport",
    opacity: 1,
    originX: "left",
    originY: "top",
    visible: true,
    fillRule: "nonzero",
    paintFirst: "fill",
    selectable: false,
    strokeWidth: 1,
    strokeLineCap: "butt",
    strokeUniform: false,
    strokeLineJoin: "miter",
    backgroundColor: "",
    strokeDashOffset: 0,
    strokeMiterLimit: 4,
    globalCompositeOperation: "source-over",
  };
  return viewport;
};

export function prepareViewportAddOrReplaceChange(
  viewPort: unknown
): Extract<CanvasDataChange, { type: "add-or-replace" }> {
  return {
    type: "add-or-replace",
    object: viewPort,
    index: 0,
  };
}


export const viewportValidator = () => {
  return z
    .string()
    .min(1)
    .refine(
      (value) => {
        try {
          if (value.includes(" ") || value.trim() !== value) {
            return false;
          }
          const { width, height } = parseViewportSize(value);
          return !isNaN(width) && !isNaN(height) && width > 0 && height > 0;
        } catch {
          return false;
        }
      },
      { message: t("template.viewportValidationError") }
    );
};
